import React, { useEffect } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGUAGES = ['en', 'da'];
const DEFAULT_LANGUAGE = 'en';

const LanguageWrapper = () => {
    const { lang } = useParams();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // If no language or unsupported language, redirect to default
        if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
            const pathWithoutLang = location.pathname.replace(/^\/[^/]*/, '');
            navigate(`/${DEFAULT_LANGUAGE}${pathWithoutLang || ''}`, { replace: true });
            return;
        }

        // Change language if it differs from current
        if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n, navigate, location.pathname]);

    // Don't render until we have a valid language
    if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
        return null;
    }

    return <Outlet />;
};

export default LanguageWrapper;
export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE };
